/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResult,
  MailboxPlaceholderDTO,
  MailboxRenderRequestDTO,
  MailboxRenderResultDTO,
  MailboxTemplateDTO,
  MailboxTemplateKind,
  MailboxTemplateUpsertDTO,
  ProblemDetails,
} from '../models/index';
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    MailboxPlaceholderDTOFromJSON,
    MailboxPlaceholderDTOToJSON,
    MailboxRenderRequestDTOFromJSON,
    MailboxRenderRequestDTOToJSON,
    MailboxRenderResultDTOFromJSON,
    MailboxRenderResultDTOToJSON,
    MailboxTemplateDTOFromJSON,
    MailboxTemplateDTOToJSON,
    MailboxTemplateKindFromJSON,
    MailboxTemplateKindToJSON,
    MailboxTemplateUpsertDTOFromJSON,
    MailboxTemplateUpsertDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface MailboxTemplateDefaultsKindPostRequest {
    kind: MailboxTemplateKind;
}

export interface MailboxTemplateIdDeleteRequest {
    id: string;
}

export interface MailboxTemplateIdGetRequest {
    id: string;
}

export interface MailboxTemplateIdPutRequest {
    id: string;
    mailboxTemplateUpsertDTO?: MailboxTemplateUpsertDTO;
}

export interface MailboxTemplatePlaceholdersGetRequest {
    kind?: MailboxTemplateKind;
}

export interface MailboxTemplatePostRequest {
    mailboxTemplateUpsertDTO?: MailboxTemplateUpsertDTO;
}

export interface MailboxTemplateRenderPostRequest {
    mailboxRenderRequestDTO?: MailboxRenderRequestDTO;
}

/**
 * 
 */
export class MailboxTemplateApi extends runtime.BaseAPI {

    /**
     */
    async mailboxTemplateDefaultsKindPostRaw(requestParameters: MailboxTemplateDefaultsKindPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxTemplateDTO>> {
        if (requestParameters['kind'] == null) {
            throw new runtime.RequiredError(
                'kind',
                'Required parameter "kind" was null or undefined when calling mailboxTemplateDefaultsKindPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/MailboxTemplate/defaults/{kind}`;
        urlPath = urlPath.replace(`{${"kind"}}`, encodeURIComponent(String(requestParameters['kind'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxTemplateDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxTemplateDefaultsKindPost(requestParameters: MailboxTemplateDefaultsKindPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxTemplateDTO> {
        const response = await this.mailboxTemplateDefaultsKindPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxTemplateGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MailboxTemplateDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/MailboxTemplate`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailboxTemplateDTOFromJSON));
    }

    /**
     */
    async mailboxTemplateGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MailboxTemplateDTO>> {
        const response = await this.mailboxTemplateGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxTemplateIdDeleteRaw(requestParameters: MailboxTemplateIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxTemplateIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/MailboxTemplate/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailboxTemplateIdDelete(requestParameters: MailboxTemplateIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailboxTemplateIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailboxTemplateIdGetRaw(requestParameters: MailboxTemplateIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxTemplateDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxTemplateIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/MailboxTemplate/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxTemplateDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxTemplateIdGet(requestParameters: MailboxTemplateIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxTemplateDTO> {
        const response = await this.mailboxTemplateIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxTemplateIdPutRaw(requestParameters: MailboxTemplateIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxTemplateDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxTemplateIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/MailboxTemplate/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxTemplateUpsertDTOToJSON(requestParameters['mailboxTemplateUpsertDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxTemplateDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxTemplateIdPut(requestParameters: MailboxTemplateIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxTemplateDTO> {
        const response = await this.mailboxTemplateIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxTemplatePlaceholdersGetRaw(requestParameters: MailboxTemplatePlaceholdersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MailboxPlaceholderDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/MailboxTemplate/placeholders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailboxPlaceholderDTOFromJSON));
    }

    /**
     */
    async mailboxTemplatePlaceholdersGet(requestParameters: MailboxTemplatePlaceholdersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MailboxPlaceholderDTO>> {
        const response = await this.mailboxTemplatePlaceholdersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxTemplatePostRaw(requestParameters: MailboxTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxTemplateDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/MailboxTemplate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxTemplateUpsertDTOToJSON(requestParameters['mailboxTemplateUpsertDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxTemplateDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxTemplatePost(requestParameters: MailboxTemplatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxTemplateDTO> {
        const response = await this.mailboxTemplatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxTemplateRenderPostRaw(requestParameters: MailboxTemplateRenderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxRenderResultDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/MailboxTemplate/render`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxRenderRequestDTOToJSON(requestParameters['mailboxRenderRequestDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxRenderResultDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxTemplateRenderPost(requestParameters: MailboxTemplateRenderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxRenderResultDTO> {
        const response = await this.mailboxTemplateRenderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
